import React, {Component} from 'react';
import {Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {deepCopyObject, hasUserRight, selectServiceData, showAxiosError} from "../../helper/helper"
import {request} from "../../helper/APIUtils";
import Table from "../../components/Table/Table";
import InboxWarning from "./components/InboxWarning";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import DefaultModal from "../invoice/DefaultModal";
import Select from "../../local_node_modules/react-select"
import Alert from "react-s-alert";
import {ACCESS_TOKEN, EntegratorConf, VirtualHost} from "../../constants/index";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import NavBarKS from "../../components/NavBarKS";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import {CopyToClipboard} from "react-copy-to-clipboard";
import XMLDownlaodRequestModal from "./components/XMLDownlaodRequestModal";
import CreditHistoryModal from "./components/CreditHistoryModal";
import CustomerNotesModal from "./components/CustomerNotesModal";
import DistributorInfoModal from "./components/DistributorInfoModal";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import StickButton from "../../components/StickButton";
import axios from 'axios';
import AssignCustomerModal from "./components/AssignCustomerModal";
import NotifyKS from "../../components/NotifyKS";
import CustomerPriceListModal from "./components/CustomerPriceListModal";
import moment from "moment";
import DeniedInboxWithErrorList from "../../components/DeniedInboxWithErrorList";
import CustomerChangeVknTcknModal from "./components/CustomerChangeVknTcknModal";
import SmsReportToExcel from "../../components/SmsReportToExcel";
import ExternalPayTrModal from "../paytr/ExternalPayTrModal";
import {
	showConnectorPayment,
	showCreditDistributeButton,
	showExternalPayment,
	showKolayAndSmart,
	showPriceListModal
} from "../../helper/permission";
import DistributorPurchaseModal from "./components/DistributorPurchaseModal";
import SweetAlertExt from "../../components/SweetAlertExt";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import ExternalPaymentModal from "./components/ExternalPaymentModal";
import SquareButton from "../../components/SquareButton";
import ConnectorPaymentModal from "../connector/ConnectorPaymentModal";
import AdditionalServicesModal from "./components/AdditionalServicesModal";
import CreditSalesByDistributorModal from "./components/CreditSalesByDistributorModal";
import CustomerRequestModal from "./components/CustomerRequestModal";
import FinancialSealModal from "./components/FinancialSealModal";
import XLSX from "xlsx";

class CustomerList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			customers: [],
			allWarningMails: [],
			loading: false,
			searching: false,
			searchQuery: undefined,
			total: 0,
			page: 0,
			size: 10,
			selectedCustomer: {},
			inboxWarningModal: false,
			disabledLoginBtn: false,
			xmlDownloadSelected: false,
			showLoginModal: false,
			showXMLDownloadRequestModal: false,
			serviceStateModal: false,
			customerPriceListModal: false,
			priceAmountMap: {},
			priceAmountMbMap: {},
			users: [],
			distributorList:[],
			manual: false,
			assignCustomerModal: false,
			selectedAccountant: null,
			assignedCustomers: [],
			notifyKey: Math.random().toString(36),
			cities:[],
			taxOffices:[],
			filteredTaxOffices: [],
			fieldsAndValues: {},
			selectedCity:null,
			changeVknTcknModal:false,
			showDeniedInboxWithError:false,
			smsExcel:false,
			isExternalPayable:true,
			source:"customerList",
			services: [],
			selection: [],
			selectedCustomerList:[],
			eBelgeUsers:[],
			priceListModal :false,
			result: null,
			code: null,
			processing: false,
			externalPaymentModal: false,
			predicate: "",
			additionalServicesModal: false,
			creditSalesByDistributorModal: false,
			showRequestModal: false,
			showFinancialSealModal: false,
			propType: null,
			checkConnectorUpdated: false,
			checkConnectorInstallation: false,
			connectorAlert: false
		};
		this.fetchData = this.fetchData.bind(this);
		this.toggle = this.toggle.bind(this);
		this.impersonate = this.impersonate.bind(this);
		this.fetchListPrices = this.fetchListPrices.bind(this);
		this.handleCreate = this.handleCreate.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleCustomizeSidebar = this.handleCustomizeSidebar.bind(this);
		this.closeInboxWarningModal = this.closeInboxWarningModal.bind(this);
		this.prepareAndShowServiceStates = this.prepareAndShowServiceStates.bind(this);
		this.closeServiceStateModal = this.closeServiceStateModal.bind(this);
		this.serviceTypesSelectData = this.serviceTypesSelectData.bind(this);
		this.openCreditHistoryModal = this.openCreditHistoryModal.bind(this);
		this.openDistributorInfoModal = this.openDistributorInfoModal.bind(this);
		this.closeDistributorInfoModal = this.closeDistributorInfoModal.bind(this);
		this.openCustomerNotesModal = this.openCustomerNotesModal.bind(this);
		this.closeCustomerNotesModal = this.closeCustomerNotesModal.bind(this);
		this.closeCreditHistoryModal = this.closeCreditHistoryModal.bind(this);
		this.handleConsole = this.handleConsole.bind(this);
		this.transferCustomer = this.transferCustomer.bind(this);
		this.closeAssignModal = this.closeAssignModal.bind(this);
		this.showNotification = this.showNotification.bind(this);
		this.openCustomerPriceListModal = this.openCustomerPriceListModal.bind(this);
		this.closeCustomerPriceListModal = this.closeCustomerPriceListModal.bind(this);
		this.getCities = this.getCities.bind(this);
		this.getTaxOffices = this.getTaxOffices.bind(this);
		this.onChangeCity = this.onChangeCity.bind(this);
		this.getDistributors = this.getDistributors.bind(this);
		this.getDistributorsAll = this.getDistributorsAll.bind(this);
		this.closeCustomerChangeVknTcknModal = this.closeCustomerChangeVknTcknModal.bind(this);
		this.findDistributor = this.findDistributor.bind(this);
		this.closeClickSms = this.closeClickSms.bind(this);
		this.isExternalPayable = this.isExternalPayable.bind(this);
		this.getCustomerType = this.getCustomerType.bind(this);
		this.openPriceListModal = this.openPriceListModal.bind(this);
		this.closePriceListModal = this.closePriceListModal.bind(this);
		this.gibState = this.gibState.bind(this);
		this.reset = this.reset.bind(this);
		this.checkRoleIdHandleSearch = this.checkRoleIdHandleSearch.bind(this);
		this.openExternalPaymentModal = this.openExternalPaymentModal.bind(this);
		this.closeExternalPaymentModal = this.closeExternalPaymentModal.bind(this);
		this.openXsltList = this.openXsltList.bind(this);
		this.copyEttn = this.copyEttn.bind(this);
		this.downloadEnvelopeXml = this.downloadEnvelopeXml.bind(this);
		this.openConnectorPaymentModal = this.openConnectorPaymentModal.bind(this);
		this.aliasFilter = this.aliasFilter.bind(this);
		this.openAdditionalServicesModal = this.openAdditionalServicesModal.bind(this);
		this.closeAdditionalServicesModal = this.closeAdditionalServicesModal.bind(this);
		this.readableOptionCodeName = this.readableOptionCodeName.bind(this);
		this.openCreditSalesByDistributorModal = this.openCreditSalesByDistributorModal.bind(this);
		this.closeCreditSalesByDistributorModal = this.closeCreditSalesByDistributorModal.bind(this);
		this.openRequestModal = this.openRequestModal.bind(this);
		this.closeRequestModal = this.closeRequestModal.bind(this);
		this.openFinancialSealModal = this.openFinancialSealModal.bind(this);
		this.closeFinancialSealModal = this.closeFinancialSealModal.bind(this);
		this.getSelcukEczaDeposuAktifMusterileri = this.getSelcukEczaDeposuAktifMusterileri.bind(this);
		this.updateVknTckn = this.updateVknTckn.bind(this);
	}

	componentDidMount() {
		if (this.props.currentUser){
			let user = this.props.currentUser;
			let customerXMLDownload = user.userRights.includes("customer_download_xml");
			this.setState({xmlDownloadSelected: customerXMLDownload});
		}
		this.getDistributorsAll();
		this.fetchListPrices()
		this.getCities()
		this.getTaxOffices();
		this.getDistributors();
		this.getServicesAll();
	}

	openFinancialSealModal(customer){
		this.setState({
			showFinancialSealModal: true,
			selectedCustomer: customer,
		});
	}

	closeFinancialSealModal(){
		this.setState({
			showFinancialSealModal: false,
			selectedCustomer: null,
		});
	}

	openRequestModal(customer) {
		this.setState({
			showRequestModal: true,
			selectedCustomer: customer,
		});
	}

	closeRequestModal() {
		this.setState({
			showRequestModal: false,
			selectedCustomer: null,
		});
	}

	aliasFilter(row) {
		if (row !== null){
			return row.aliasList.filter((alias) => alias.serviceId === 1 || alias.serviceId === 2).length > 0;
		} else {
			return false;
		}
	}

	openAdditionalServicesModal(customer) {
		this.setState({additionalServicesModal: true,
			selectedCustomer: customer})
	}

	closeAdditionalServicesModal() {
		this.setState({additionalServicesModal: false})
	}

	openCreditSalesByDistributorModal() {
		this.setState({creditSalesByDistributorModal: true});
	}

	closeCreditSalesByDistributorModal() {
		this.setState({creditSalesByDistributorModal: false});
	}

	fetchListPrices() {
		let self = this;
		let params = {
			url: '/customer/fetchPriceAmountMaps',
			method: "post",
		};
		request(params)
			.then(function (response) {
				let allPrices = response.data;
				let listPrices = allPrices.listPrices;
				let listPricesMb = allPrices.listPricesMb;
				self.setState({
					priceAmountMap: listPrices,
					priceAmountMbMap: listPricesMb
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	handleEdit(item) {
		this.props.history.push(`/createEditCustomer/${item.recordId}`);
	}

	openXsltList(item) {
		this.props.history.push(`/xsltYonetimi/${item.recordId}`)
	}

	handleCustomizeSidebar(item) {
		this.props.history.push(`/customizeSidebar/${item.recordId}`);
	}

	handleCreate() {
		this.props.history.push(`/createEditCustomer/0`);
	}

	handleConsole() {
		let params = {
			url: '/common/reloadAll/',
			method: "post"
		};

		request(params)
			.then(function (response) {
				Alert.success("Listelerin yenilenme işlemi tamamlandı. Portal properties yeniden yüklendi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 1500
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	copyEttn() {
		Alert.success("Zarf Ettn Kopyalandı.", {
			position: 'top-right',
			effect: 'stackslide',
			timeout: 2000
		});
	}

	downloadEnvelopeXml(row, index) {

		if (row.envelopeUuid !== null) {
			let params = {
				url: '/userOutboxEnvelope/downloadMedia',
				method: 'post',
				data: row.envelopeUuid
			}
			request(params).then((response) => {
				let blob = new Blob([response.data], {type: response.headers["content-type"]});
				let urlCreator = window.URL || window.webkitURL;
				let url = urlCreator.createObjectURL(blob);

				let a = document.createElement("a");
				document.body.appendChild(a);
				a.style = "display: none";
				a.href = url;
				a.download = row.envelopeUuid + ".xml";
				a.click();
			}) .catch((err) => {
				Alert.error("Şuan işleminiz gerçekleştirilemiyor, lütfen daha sonra tekrar deneyiniz.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 8000
				});
			})
		} else {
			Alert.error("Zarf Ettn Boş Olamaz!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
		}
	}

	fetchData(accessor, direction, page, size) {
		if (this._source)
			this._source.cancel();

		let self = this;
		this._source = axios.CancelToken.source();
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let propName = this.props.name;
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/' + propName + '/fetch?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "get",
			cancelToken: self._source.token,
		};
		self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		if (self.props.currentUser.roleId === 3 && (self.state.searchQuery === undefined || self.state.searchQuery === null)) {
			self.props.reload(false);
			self.setState({loading: false, searching: false});
		}  else {
			request(params)
				.then(function (response) {
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						customers: response.data.content,
						loading: false,
						searching: false,
						predicate: '?page=' + page + '&size=' + size + sortStr + searchQuery === '?page=0&size=10&sort=recordId,desc'? ''
						:'?page=' + page + '&size=' + size + sortStr + searchQuery,
						selection:[],
						selectedCustomerList:[]
					});
					self.props.reload(false);
				}).catch(function (error) {
				self.props.reload(false);
				self.setState({loading: false, searching: false});
				showAxiosError(error);
			});
		}
	}

	openInboxWarningModal(row) {
		let self = this;
		let params = {
			url: '/customer/getAllInboxWarnings',
			method: "post",
			data: row.vknTckn
		};
		request(params)
			.then(function (response) {
				self.setState({
					allWarningMails: response.data,
					selectedCustomer: row,
					inboxWarningModal: true
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	getCustomerUser(row) {
		let self = this;
		let params = {
			url: '/customer/getCustomerUser',
			method: "post",
			data: {
				recordId: row.recordId
			}
		};
		this.setState({getCustomerLoading: true});
		request(params)
			.then(function (response) {
				let data = response.data;
				let users = data.users;
				let recordId = (users.length === 0 ? null : users[0][5]);
				self.setState({users: data.users, showLoginModal: true, getCustomerLoading: false, recordId: recordId});
			}).catch(function (error) {
			showAxiosError(error);
			self.setState({showLoginModal: false, getCustomerLoading: false});
		});
	}

	impersonate() {
		let recordId = this.state.recordId;
		if (recordId) {
			this.setState({disabledLoginBtn: true});
			let self = this;
			let params = {
				url: '/user/impersonate',
				method: "post",
				data: {
					recordId: recordId
				}
			};
			request(params)
				.then(function (response) {
					let data = response.data;
					localStorage.setItem(ACCESS_TOKEN, data.accessToken);
					self.props.onLogin();
					self.props.onImpersonate(true);
					self.setState({disabledLoginBtn: false});
				}).catch(function (error) {
				showAxiosError(error);
				self.setState({disabledLoginBtn: false});
			});
		} else {
			Alert.error("Kullanıcı seçimi yapmalısınız.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 1500
			});
		}
	}

	closeInboxWarningModal() {
		this.setState({
			selectedCustomer: null,
			inboxWarningModal: false
		})
	}

	handleSearch(searchQuery) {
		if(searchQuery.includes("isDistributor=2")){
			searchQuery = searchQuery.replace("isDistributor=2", "isAccountant=1")
		}
		if(searchQuery.includes("aliases.processState=500,")){
			searchQuery = searchQuery.replace("aliases.processState=500,","aliases.processState=500&aliases.processResult=")
		}
		if(searchQuery.includes("aliases.processState=S")){
			searchQuery = searchQuery.replace("aliases.processState=S", "aliases.processResult=1300")
		}
		if(searchQuery.includes("aliases.processState=P")){
			searchQuery = searchQuery.replace("aliases.processState=P", "aliases.processResult=0" + "&aliases.processResult=1" + "&aliases.processResult=1000" +
				"&aliases.processResult=1100" + "&aliases.processResult=1190" + "&aliases.processResult=1200" + "&aliases.processResult=1210" + "&aliases.processResult=1220" )
		}
		if(searchQuery.includes("aliases.processState=F")){
			searchQuery = searchQuery.replace("aliases.processState=F", "aliases.processResult=3" + "&aliases.processResult=1110" + "&aliases.processResult=1111" +
				"&aliases.processResult=1120" + "&aliases.processResult=1130" + "&aliases.processResult=1131" + "&&aliases.processResult=1132" + "&aliases.processResult=1133" +
				"&aliases.processResult=1140" + "&aliases.processResult=1141" + "&aliases.processResult=1142" + "&aliases.processResult=1143" + "&aliases.processResult=1150" +
				"&aliases.processResult=1160" + "&aliases.processResult=1161" + "&aliases.processResult=1162" + "&aliases.processResult=1163" + "&aliases.processResult=1170" +
				"&aliases.processResult=1171" + "&aliases.processResult=1172" + "&aliases.processResult=1175" + "&aliases.processResult=1176" + "&aliases.processResult=1177" +
				"&aliases.processResult=1180" + "&aliases.processResult=1181" + "&aliases.processResult=1182" + "&aliases.processResult=1183" + "&aliases.processResult=1195" +
				"&aliases.processResult=1215" + "&aliases.processResult=1230" + "&aliases.processResult=2000" + "&aliases.processResult=2001" + "&aliases.processResult=2002" +
				"&aliases.processResult=2003" + "&aliases.processResult=2004" + "&aliases.processResult=2005" + "&aliases.processResult=2006" + "&aliases.processResult=2007")
		}
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	queryServiceState(row) {
		let self = this;
		let params = {
			url: '/customer/fetchServiceState',
			method: "post",
			data: row.recordId
		};
		request(params)
			.then(function (response) {
				!!response.data && self.prepareAndShowServiceStates(response.data);
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	transferCustomer(row) {
		let self = this;
		let params = {
			url: '/customer/transferCustomer',
			method: "post",
			data: row.recordId
		};
		request(params)
			.then(function (response) {
				Alert.success("Müşteri başarıyla taşındı.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({manual: true});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	showVknTcknChanging(row){
		let isChangeable = true;
		row.aliasList && row.aliasList.map(a => {
			if ((a.processState === 500 && a.processResult === 1300 && a.gibRegistrationState === true) || (a.processState === 300 && a.processResult === 1300 && a.gibRegistrationState === true)) {
				isChangeable = false;
			}
		})
		return isChangeable
	}

	defineServiceStateIcon(row) {
		if(row.aliasList && row.aliasList.length === 0)
			return <label/>

		let complete = true;
		let completeCancel = true;
		let waitingSendGib = false;
		row.aliasList && row.aliasList.map(a => {
			if (!(a.processState === 500 && a.processResult === 1300) && !(a.processState === 300 && a.processResult === 1300)) {
				complete = false;
				if (a.processState === 180 && a.processResult === 0) {
					waitingSendGib = true;
				}
			}
		});

		if (complete) {
			row.aliasList && row.aliasList.map(a => {
				if (a.actionType === "C")
					completeCancel = false;
			});
			if (completeCancel) {
				return <label onClick={() => this.queryServiceState(row)} className="fas fa-check"
							  style={{color: '#9fd037', fontSize: '1.2em', cursor: 'pointer'}}/>;
			} else {
				return <label onClick={() => this.queryServiceState(row)} className="fas fa-check"
							  style={{color: '#e57f23', fontSize: '1.2em', cursor: 'pointer'}}/>;
			}
		} else {
			if (waitingSendGib) {
				return <a><label onClick={() => this.queryServiceState(row)} className="fas fa-location-arrow"
								 style={{color: '#4682B4', fontSize: '1.2em', cursor: 'pointer'}}/></a>
			} else {
				return <a><label onClick={() => this.queryServiceState(row)} className="fas fa-exclamation"
								 style={{color: '#F2421B', fontSize: '1.2em', cursor: 'pointer'}}/></a>;
			}
		}
	}

	findDistributor(row) {
		if (this.state.distributorList.length > 0 && showKolayAndSmart(EntegratorConf.identifier)) {
			let distributors = deepCopyObject(this.state.distributorList);
			return distributors.map(distributor => {
				if (distributor[0] === row.parentCustomerId) {

					const distributor3 = (distributor[3] != null) && (distributor[3] !== "") ? distributor[3].trimEnd() : '';
					const distributor4 = (distributor[4] != null) && (distributor[4] !== "") ? distributor[4].trimEnd() : '';
					const distributor7 = (distributor[7] != null) && (distributor[7] !== "") ? distributor[7].trimEnd() : '';
					const distributor8 = (distributor[8] != null) && (distributor[8] !== "") ? distributor[8].trimEnd() : '';


					const mainDistributor = (distributor[1].length === 10 ? distributor[2] : `${distributor3} ${distributor4}`);
					const secondaryDistributor = (distributor[5].length === 10 ? distributor[6] : `${distributor7} ${distributor8}`);

					if ( row && this.props.currentUser &&
						((row.accountant === true && row.isDistributor === false) || (distributor[9] === 0 && distributor[10] === 1)) &&
						(this.props.currentUser.customerId !== row.parentCustomerId))
					{
						return mainDistributor + ` (${secondaryDistributor})`;
					}
					else if (this.props.currentUser.customerId === row.parentCustomerId){
						return mainDistributor + ` (${secondaryDistributor})`;
					}
					else {
						return mainDistributor;
					}
				}
			}).filter(distributor => distributor !== undefined);
		} else if (this.state.distributorList.length > 0) {
			let distributors = deepCopyObject(this.state.distributorList);
			return distributors.map(distributor => {

				const distributor3 = (distributor[3] != null) && (distributor[3] !== "") ? distributor[3].trimEnd() : '';
				const distributor4 = (distributor[4] != null) && (distributor[4] !== "") ? distributor[4].trimEnd() : '';
				const distributor7 = (distributor[7] != null) && (distributor[7] !== "") ? distributor[7].trimEnd() : '';
				const distributor8 = (distributor[8] != null) && (distributor[8] !== "") ? distributor[8].trimEnd() : '';

				if (distributor[0] === row.parentCustomerId) {
					return (distributor[1] !== this.state.distributorList[0][1] && distributor[5] !== this.state.distributorList[0][1]) ?
						(distributor[1].length === 10 ? distributor[2] : `${distributor3} ${distributor4}`) + (' (' + (distributor[5].length === 10 ? distributor[6] : `${distributor7} ${distributor8}`) + ')') :
						(distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4]));
				}
			}).filter(distributor => distributor !== undefined);
		} else {
			return "";
		}
	}



	async prepareAndShowServiceStates(data) {
		let aliases = data.aliases;
		let userOutboxEnvelopes = data.userOutboxEnvelopes;

		let serviceStateList = [];

		aliases.map(async alias => {
			let serviceState = {};
			serviceState.userOptioncode = alias.userOptioncode;
			serviceState.serviceName = alias.service.ublCode;
			serviceState.workScopecode = alias.workScopecode ? alias.workScopecode : '-';
			serviceState.actionType = alias.actionType === 'P' ? 'Kayıt' : 'İptal';
			serviceState.processStartDate = moment(alias.processStartDate).isValid() ? moment(alias.processStartDate).format("DD-MM-YYYY HH:mm:ss") : '-';
			serviceState.explanation = await this.prepareServiceStateExplanation(alias, data);
			serviceState.envelopeUuid = alias.envelopeUuid;

			let isAtGib;
			if (alias.envelopeUuid) {
				isAtGib = alias.processState > 180 && alias.processResult !== 1300
				serviceState.envelopeUuid = alias.envelopeUuid;
			}

			let gibDate;
			userOutboxEnvelopes.map(envelope => {
				if (envelope.envelopeUuid === alias.envelopeUuid) {
					gibDate = envelope.sendDate !== null ? envelope.sendDate : envelope.processState > 180 ? envelope.receivedDate : "-";
				}
			})
			serviceState.isAtGib = isAtGib
			serviceState.gibDate = gibDate && moment(gibDate).isValid() ? moment(gibDate).format("DD-MM-YYYY HH:mm:ss") : '-';
			serviceStateList.push(serviceState);

			this.setState({serviceStateList: [...serviceStateList]}, () => this.openServiceStateModal())

		});
	}

	async prepareServiceStateExplanation(alias, data) {
		if (alias.resultExplanation === null) {
			let stateCodePayload = {};
			if (alias.processState < 130) {
				stateCodePayload.processState = alias.processState;
				stateCodePayload.processResult = alias.processResult;

				let result = await this.fetchStateExplanation(stateCodePayload);

				return result;

			} else {
				let uoe = null;
				if (data.userOutboxEnvelopes.length > 0) {
					uoe = data.userOutboxEnvelopes.filter(uoe => {
						if (alias.envelopeUuid !== null) {
							return uoe.envelopeUuid === alias.envelopeUuid;
						} else {
							return null;
						}
					});
				}

				let isWithoutEnvelope = false
				if(alias.service.recordId === 5 || alias.service.recordId === 121 || alias.service.recordId === 122 || alias.service.recordId === 123 || alias.service.recordId === 124 ){
					isWithoutEnvelope = true;
				}

				if (!!uoe && !!uoe[0] || isWithoutEnvelope) {
					if (!isWithoutEnvelope && uoe[0].processState === 130 && uoe[0].processResult === 0) {
						return 'Müşteri Tarafından İmzalanması Bekleniyor'

					} else if (!isWithoutEnvelope && uoe[0].processState === 180 && uoe[0].processResult === 0) {
						return 'GİB Gönderimi Bekliyor'
					} else {
						if(isWithoutEnvelope){
							stateCodePayload.processState = alias.processState;
							stateCodePayload.processResult = alias.processResult
						} else {
							stateCodePayload.processState = uoe[0].processState;
							stateCodePayload.processResult = uoe[0].processResult;
						}

						let result = await this.fetchStateExplanation(stateCodePayload);

						return result;
					}
				} else {
					if (alias.service && (alias.service.recordId === 3 || alias.service.recordId === 4)) {
						return '-'
					} else {
						return 'Zarf Karşılığı Bulunamadı';
					}
				}
			}
		}
		else
			return alias.resultExplanation;
	}

	async fetchStateExplanation(data) {
		let params = {
			url: '/customer/fetchStateExplanation',
			method: "post",
			data: data
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data
			}).catch(function (error) {
				showAxiosError(error);
			});

		return result;
	}

	openServiceStateModal() {
		this.setState({serviceStateModal: true})
	}

	closeServiceStateModal() {
		this.setState({serviceStateModal: false})
	}

	serviceTypesSelectData() {
		//TODO: Sorun olmaması durumunda kaldırılacak.
		let data = selectServiceData();
		data.splice(-1, 1);
		return data;
	}

	copied(workScopecode) {
		if (workScopecode) {
			Alert.success("Hizmet etiketi:<br/><strong>" + workScopecode + "</strong><br/> kopyalandı", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	openCreditHistoryModal(customer) {
		this.setState({
			creditHistoryModal: true,
			selectedCustomer: customer
		})
	}

	openExternalPaymentModal(customer) {
		this.setState({
			externalPaymentModal: true,
			selectedCustomer: customer
		})
	}

	openCustomerNotesModal(customer) {
		this.setState({
			customerNotesModal: true,
			selectedCustomer: customer
		})
	}

	openDistributorInfoModal(customer) {
		this.setState({
			distributorInfoModal: true,
			selectedCustomer: customer

		})
	}

	closeDistributorInfoModal() {
		this.setState({
			distributorInfoModal: false,
			selectedCustomer: null
		})
	}

	closeCreditHistoryModal() {
		this.setState({
			creditHistoryModal: false,
			selectedCustomer: null
		})
	}

	closeExternalPaymentModal() {
		this.setState({
			externalPaymentModal: false,
			selectedCustomer: null
		})
	}

	openPriceListModal(){
		this.setState({
			priceListModal: true,
			selectedCustomer: this.props.currentUser
		})
	}

	closePriceListModal() {
		this.setState({
			priceListModal: false,
			selectedCustomer: null
		})
	}

	closeCustomerNotesModal() {
		this.setState({
			customerNotesModal: false,
			selectedCustomer: null
		})
	}

	openCustomerPriceListModal(customer) {
		this.setState({
			customerPriceListModal: true,
			selectedCustomer: customer
		})
	}

	closeCustomerPriceListModal() {
		this.setState({
			customerPriceListModal: false,
			selectedCustomer: null
		})
	}

	openConnectorPaymentModal(customer){
		this.setState({
			connectorPaymentModal: true,
			selectedCustomer: customer
		})
	}

	openAssignModal(row) {
		let self = this;
		self.setState({ loading: true });

		let params = {
			url: '/customer/fetchAssignedCustomers',
			method: "post",
			data: row.recordId
		};

		request(params)
			.then(function (response) {
				self.setState({
					loading: false,
					assignCustomerModal: true,
					selectedAccountant: row.recordId,
					assignedCustomers: response.data
				});
			})
			.catch(function (error) {
				showAxiosError(error);
				self.setState({ loading: false });
			});
	}


	closeAssignModal() {
		this.setState({
			assignCustomerModal: false,
			selectedAccountant: null,
			assignedCustomers: []
		})
	}

	openCustomerChangeVknTcknModal(customer){
		this.setState(
			{
				selectedCustomer:customer,
				changeVknTcknModal:true
			});
	}

	closeCustomerChangeVknTcknModal(){
		this.setState({
			changeVknTcknModal:false,
			selectedCustomer:null
		});
	}

	showNotification(type, message) {
		this.setState({
			notifyKey: Math.random().toString(36),
			notify: {
				type: type,
				message: message,
			}
		})
	}

	async getCities(){
		let self = this;
		let params = {
			url: '/customer/getCities',
			method: "post",
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data

			}).catch(function (error) {
				showAxiosError(error);
			});
		self.setState({cities:result});



	}

	async getTaxOffices(){
		let self = this;
		let params = {
			url: '/customer/getTaxOffices',
			method: "post",
		};
		let result = null;
		await request(params)
			.then(function (response) {
				result = response.data
			}).catch(function (error) {
				showAxiosError(error);
			});

		self.setState({taxOffices:result});

	}

	getCitiesSelectData(){
		let cities= [{value:null, label:"Tümü"}];
		this.state.cities.map(c => (cities.push({value: c.cityName, label: c.cityName})));

		return cities;
	}

	getTaxOfficesSelectData(){
		let filteredTaxOffices = [{value:null, label:"Tümü"}];

		this.state.filteredTaxOffices = this.state.taxOffices.filter(to => to.city === this.state.selectedCity)
		this.state.filteredTaxOffices.map(to => (filteredTaxOffices.push({value: to.vdName, label: to.vdName})));


		return filteredTaxOffices;
	}

	onChangeCity(selectedCity){
		this.setState({selectedCity})
	}

	getDistributors() {
		let self = this;
		let params = {
			url: `/progresspayment/getDistributors`,
			method: "post"
		};
		if (self.props.currentUser.roleId !== 3) {
			request(params)
				.then(function (response) {
					let {distributors,allDistributors} = response.data;
					let distributorMap = allDistributors.reduce(function(map, obj) {
						map[obj.recordId] = obj.customerName;
						return map;
					}, {});

					distributors = distributors.map(distributor => ({
						value: distributor.recordId,
						label: distributor.customerName
					}));

					if(self.props.currentUser.isEntegrator) {
						distributors.push({
							value: self.props.currentUser.customerId,
							label: self.props.currentUser.formattedName
						});
					}
					distributors.unshift({value: null, label: 'Tümü'});
					self.setState({distributors,distributorMap});
				}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	closeClickSms() {
		this.setState({smsExcel: false});
	}

	async getDistributorsAll() {
		let self = this;
		let params = {
			url: "/customer/getDistributors",
			method: "get"
		};
		await request(params)
			.then(response => {
				self.setState({distributorList: response.data});
			}).catch(error => {
			});
	}

	getServicesAll() {
		let self = this;
		let params = {
			url: "/customer/services",
			method: "get"
		};
		request(params)
			.then(response => {
				self.setState({services: response.data.map(services => ({
						value: services.recordId,
						label: services.ublCode
					}))
			});
	})
	}

	toggle(e, row, id) {
		let self = this;
		let checked = e.target.checked;
		let items = self.state.customers;
		let selection = self.state.selection;
		let selectedCustomerList = self.state.selectedCustomerList;
		if (row === "all") {
			let selection = [];
			let selectedCustomerList = [];
			if (checked) {
				items.forEach(item => {
					selection.push(item[id]);
					selectedCustomerList.push(item);
				});
			}
			self.setState({selection,selectedCustomerList, selectedAll: checked});
		} else {
			let index = selection.indexOf(row[id]);
			let indexCustomer = selectedCustomerList.indexOf(row);
			if (index >= 0) {
				selection = [
					...selection.slice(0, index),
					...selection.slice(index + 1)
				];
				selectedCustomerList = [
					...selectedCustomerList.slice(0, indexCustomer),
					...selectedCustomerList.slice(indexCustomer + 1)
				];
			} else {
				selection.push(row[id]);
				selectedCustomerList.push(row);
			}
			self.setState({
				selection,
				selectedCustomerList,
				selectedAll: ((selection.length > 0) ? (selection.length === self.state.customers.length) : false)
			});
		}
	}

	isSelected(id) {
		return (this.state.selection.indexOf(id) !== -1);
	}

	isExternalPayable(){
		let selectedCustomerList = deepCopyObject(this.state.selectedCustomerList);
		let eBelgeUsers = [];
		selectedCustomerList.map(item => {
			let found = false;
			item.aliasList.map(alias =>{
				if (alias.serviceId === 124 && alias.actionType === "P" && alias.processState === 500 && alias.processResult === 1300 && !alias.gibRegistrationState){
					found = true;
				}
			});
			if (found){
				eBelgeUsers.push(item);
			}
		});
		this.setState({eBelgeUsers, externalModal:true});
	}

	getCustomerType(row){
		return row.isDistributor ? "Bayi" : (row.accountant ? "Muhasebeci" : "Müşteri");
	}

	gibState(row) {
		let self = this;
		let envelopeUuid = row.envelopeUuid
		let formData = new FormData();
		formData.append("envelopeUuid", envelopeUuid);

		let params = {
			url: "/userOutboxEnvelope/queryEnvelope",
			method: 'post',
			data: formData
		};

		self.setState({processing: true, result: null, code: null});
		request(params).then(function (response) {
			self.setState({
				result: response.data.result,
				code: response.data.code,
				processing: false,
			});
		}).catch(function (error) {
			self.setState({processing: false});
			showAxiosError(error);
		});
	}

	reset() {
		this.setState({
			result: null,
			envelopeUuid: "",
			processing: false
		})
	}

	checkRoleIdHandleSearch(searchQuery) {

		let value = searchQuery.split("&")
		let result = {val:true, errorField: []}
		value.map((e) => {
			if (e.split("=")[0] === "customerName" && e.split("=")[1].length < 3) {
				result.val = false;
				result.errorField.push("Müşteri Adı ")
			}
			if (e.split("=")[0] === "formattedName" && e.split("=")[1].length < 3) {
				result.val =  false;
				result.errorField.push("Ünvan ")
			}
			if (e.split("=")[0] === "givenName" && e.split("=")[1].length < 3) {
				result.val =  false;
				result.errorField.push("Ad ")
			}
			if (e.split("=")[0] === "familyName" && e.split("=")[1].length < 3) {
				result.val = false;
				result.errorField.push("Soyad ")
			}
			if (e.split("=")[0] === "vknTckn" && e.split("=")[1].length < 3) {
				result.val = false;
				result.errorField.push("VKN/TCKN ")
			}
		})

		if (searchQuery === "") {
			result.val = false
		}

		if (result.val === true) {
			this.handleSearch(searchQuery)
		} else {
				if (result.errorField.length === 0) {
					let error = {response:{data: "Lütfen parametre giriniz!"}};
					showAxiosError(error)
				} else {
					let error = {response:{data: `${result.errorField} en az 3 karakter olmalıdır!`}};
					showAxiosError(error)
				}
		}
	}

	readableOptionCodeName(key) {
		switch (key) {
			case 1:
			case 11:
			case 21:
			case 31:
			case 41:
			case 51:
			case 61:
			case 71:
			case 81:
			case 91:
			case 101:
			case 111:
			case 121:
			case 131:
			case 141:
			case 151:
			case 161:
				return 'Kamu';
			case 2:
			case 12:
			case 22:
			case 32:
			case 42:
			case 52:
			case 62:
			case 72:
			case 82:
			case 92:
			case 102:
			case 112:
			case 122:
			case 132:
			case 142:
			case 152:
			case 162:
				return 'Özel';
			case 3:
			case 13:
			case 23:
			case 33:
			case 43:
			case 53:
			case 63:
			case 73:
			case 83:
			case 93:
			case 103:
				return 'Vuk 507 Kamu';
			case 4:
			case 14:
			case 24:
			case 34:
			case 44:
			case 54:
			case 64:
			case 74:
			case 84:
			case 94:
			case 104:
				return 'Vuk 507 Özel';
			default :
				return '-';
		}
	}

	getSelcukEczaDeposuAktifMusterileri() {
		let self = this;

		let params = {
			url: "/customer/getSelcukEczaDeposuAktifMusterileri",
			method: 'get'
		};

		self.setState({loading: true});
		request(params).then(function (response) {
			if (response && response.data && response.data.length > 0) {
				let data = [];
				data.push(
					{
						vknTckn: "Vkn/Tckn",
						formattedName: "Eczane Adı",
						givenName: "Ad",
						familyName: "Soyad",
						city: "Şehir"
					}
				);

				response.data.map(line => {
					data.push(
						{
							vknTckn: line["vknTckn"] || "",
							formattedName: line["formattedName"] || "",
							givenName: line["givenName"] || "",
							familyName: line["familyName"] || "",
							city: line["city"] || ""
						}
					);
				});

				/* make the worksheet */
				let ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});

				/* add to workbook */
				let wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, "Sayfa_1");

				/* generate an XLSX file */
				XLSX.writeFile(wb, "Selçuk Ecza Deposu Aktif Müşteri Listesi_" + moment().format("YYYY_MM_DD_HH_mm_ss") + ".xlsx");
			}
			self.setState({loading: false});
		}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	updateVknTckn(editCustomer){
		let self = this;
		if(editCustomer.newVknTckn.length === 0)
			return;

		editCustomer["oldVknTckn"] = self.state.selectedCustomer.vknTckn;

		let params = {
			url: '/customer/customerChangeVknTckn',
			method: "post",
			data:editCustomer
		};
		request(params)
			.then((response)=>{
				Alert.success(response.data,{
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
				this.fetchData();
			}).catch((error)=>{
			showAxiosError(error);
		})
	}

	render() {
		const defaultHeaders = headerContent.customerContent;

		const customerTypeSelectData =[{value:null,label:"Tümü"},{value:"0",label:"Müşteri"},{value:"1",label:"Bayi"},{value:"2",label:"Muhasebeci"}];

		const customerIsActiveSelectData = [{value: null, label: "Tümü"}, {value: "0", label: "Pasif"}, { value: "1", label: "Aktif" }];

		const aliasState = [{value: null, label: "Tümü"},
			{value: "100", label: "Entegratör tarafından işleniyor.(100)"},
			{value: "120", label: "Entegratör tarafından işleniyor.(120)"},
			{value: "130", label: "Müşteri tarafından imza bekliyor."},
			{value: "140", label: "Entegratör tarafınan işleniyor.(140)"},
			{value: "180", label: "Gib gönderimi bekliyor."},
			{value: "500", label: "Gib'e gönderildi."},
			{value: "500,1300", label: "Başarıyla Tamamlandı."},
			{value: "500,1177", label: "Geçersiz İmza."},
			{value: "500,1182", label: "Kullanıcı Eklenemedi."},
			{value: "500,1183", label: "Kullanıcı Silinemedi."},
			{value: "S", label: "İşlem Başarılı"},
			{value: "F", label: "İşlem Başarısız"},
			{value: "P", label: "İşlem Devam Ediyor"}];

		const actionType =[{value: null, label: "Tümü"}, {value:"C", label:"İptal"}, {value:"P", label:"Aktivasyon"}]

		const columns = [
			{
				Header: (<input type="checkbox"
								checked={this.state.selectedAll}
								onChange={(e) => this.toggle(e, "all", "recordId")}/>),
				accessor: "recordId",
				selectType: "checkbox",
				sortable: false,
				Cell: (row, index) => (<input type="checkbox"
											  checked={this.isSelected(row.recordId)}
											  onChange={(e) => this.toggle(e, row, "recordId", index)}/>)
			},
			{
				Header: "Ünvan",
				accessor: "formattedName",
				Cell: row => (
					<div>
						{row.vknTckn.length === 10 ? <TextOverFlowTooltip text={row.formattedName} maxLength={20}/> :
							<TextOverFlowTooltip text={row.givenName + ' ' + row.familyName} maxLength={20}/>}
					</div>
				)
			},
			{
				Header: "VKN/TCKN",
				accessor: "vknTckn"
			},
			{
				Header: "Kurumsal e-Posta",
				accessor: "corporateMail"
			},
			{
				Header: "Vergi Dairesi",
				accessor: "taxOffice"
			},
			{
				Header: "Müşteri Tipi",
				accessor: "isDistributor",
				Cell: row => (
					<div>{this.getCustomerType(row)}</div>
				)
			},
			{
				Header: "Bayi",
				accessor: "parentCustomerId",
				Cell: row => (
					<div>{this.findDistributor(row)}</div>
				)
			},
			{
				Header: "Hizmet Durumu",
				accessor: "",
				sortable: false,
				Cell: row => (
					<div>{this.defineServiceStateIcon(row)}</div>
				)
			},
			{
				Header: "İşlemler",
				accessor: "",
				sortable: false,
				width: "11%",
				Cell: row => (
					<div className="btn-group">
						<div className="dropdown">
							<button className="MenuBtn2 listt btn btn-default" type="button" data-toggle="dropdown">Seçİnİz
							</button>
							<div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>

								{(!(!this.props.isDistributor && this.props.currentUser.accountant) || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
								<a className="dropdown-item" onClick={() => this.handleEdit(row)}>
									<i className="fa fa-edit"/> Müşteri Bilgilerini Düzenle
								</a>}
								{ false && this.aliasFilter(row) &&
								<a className="dropdown-item" onClick={() => this.openAdditionalServicesModal(row)}>
									<i className="fa fa-edit"/> Müşteri Ek Hizmetlerini Düzenle
								</a>}

								{EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier &&
									this.props.currentUser &&
									this.props.isEntegrator &&
									this.props.isAdmin &&
									row.vknTckn === "7590053879" &&
									<a className="dropdown-item" onClick={() => this.getSelcukEczaDeposuAktifMusterileri()}>
										<i className="fa fa-edit"/> Selçuk Ecza Deposu Aktif Müşteri Listesi
									</a>
								}

								{(((this.props.currentUser.roleId && this.props.currentUser.roleId !== 5 && this.props.currentUser.roleId !== 3 && !(!this.props.isDistributor && this.props.currentUser.accountant)) || this.props.currentUser.roleId === 4) && (this.props.impersonateUserRoleId !== 3)) &&
								<a className="dropdown-item" onClick={() => this.openCreditHistoryModal(row)}>
									<i className="fa fa-turkish-lira"/> Kontör İşlemleri
								</a>}

								{((
										EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
										EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
										EntegratorIdentifiers.AKTIF === EntegratorConf.identifier ||
										EntegratorIdentifiers.MBT === EntegratorConf.identifier
									) && (this.props.currentUser && this.props.isEntegrator && (this.props.isAdmin || this.props.currentUser.roleId === 4)))&&
									<a className="dropdown-item" onClick={() => this.openExternalPaymentModal(row)}>
										<i className="fa fa-turkish-lira"/> Harici Ödeme
									</a>
								}

								{(!(!this.props.isDistributor && this.props.currentUser.accountant) || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
								<a className="dropdown-item" onClick={() => this.openInboxWarningModal(row)}>
									<i className="fa fa-exclamation-triangle"/> Gelen Fatura Uyarı Bilgileri
								</a>}

								{((!(!this.props.isDistributor && this.props.currentUser.accountant) || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5))) && ( this.props.currentUser.roleId !== 3 && this.props.currentUser.roleId !== 4 ) && ((this.props.impersonateUserRoleId !== 3 && this.props.impersonateUserRoleId !== 4)) && (this.state.xmlDownloadSelected)) &&
								<a className="dropdown-item" onClick={() => this.setState({selectedCustomer: row, showXMLDownloadRequestModal: true})}>
									<i className="fa fa-download"/> Müşteri XML'lerini İndir
								</a>}

								{(!(!this.props.isDistributor && this.props.currentUser.accountant) || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
								<a className="dropdown-item" onClick={() => this.transferCustomer(row)}>
									<i className="fa fa-angle-double-right"/> Müşteriyi Taşı
								</a>}

								{(this.props.currentUser && this.props.currentUser.entegrator && row.isDistributor && !["111111444","111111888"].includes(this.props.currentUser.username) && this.props.currentUser.roleId !== 3) &&
								<a className="dropdown-item" onClick={() => this.openCustomerPriceListModal(row)}>
									<i className="fa fa-edit"/> Bayi Fiyat Listesi
								</a>}

								{/*{(this.props.currentUser && this.props.currentUser.isDistributor && this.props.currentUser.workType === 2 && showConnectorPayment(EntegratorConf.identifier)) &&*/}
								{/*	<a className="dropdown-item" onClick={() => this.openConnectorPaymentModal(row)}>*/}
								{/*		<i className="fa fa-edit"/> Konnektör Ödeme Talebi*/}
								{/*	</a>}*/}

								{(row.vknTckn === '9240517454' ? this.props.isAdmin : true) &&
									(this.props.allowPrivateAccess || (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
									this.props.impersonateUserRoleId !== 3 &&
									hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, this.props.currentUser) &&
								<a className="dropdown-item" onClick={() => this.getCustomerUser(row)}>
									<i className="fa fa-desktop"/> Kullanıcı Portalına Git
								</a>
								}
								{hasUserRight(UserRightsEnum.entegratorSettings.customerXsltManagement, this.props.currentUser) &&
									<a className="dropdown-item" onClick={() => this.openXsltList(row)}>
										<i className="fa fa-random"/> Müşteri Xslt Yönetimi
									</a>
								}
								{row.accountant &&
									<a className="dropdown-item" onClick={() => this.openAssignModal(row)}>
										<i class="far fa-id-badge"/> Müşteri Ata / Çıkart
									</a>
								}
								{this.showVknTcknChanging(row) &&
								<a className="dropdown-item" onClick={() => this.openCustomerChangeVknTcknModal(row)}>
									<i className="far fa-id-badge"/> Müşteri Vkn/Tckn Değiştir
								</a>
								}

								{(this.props.currentUser.entegrator &&
								 (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier || EntegratorIdentifiers.SMART === EntegratorConf.identifier || EntegratorIdentifiers.MBT === EntegratorConf.identifier)) &&
									<a className="dropdown-item" onClick={() => this.openCustomerNotesModal(row)}>
										<i className="fa fa-edit"/> Müşteri Notları
									</a>
								}
								{(this.props.currentUser.entegrator && this.props.isAdmin && (
										EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
										EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
										EntegratorIdentifiers.MBT === EntegratorConf.identifier
									)) &&
									<a className="dropdown-item" onClick={() => this.openDistributorInfoModal(row)}>
										<i className="fa fa-info-circle"/> <span> Bayi Bilgileri</span>
									</a>
								}

								{
									(
										(
											(this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4) ||
											(this.props.currentUser.entegrator && this.props.isAdmin)
										) && (
											EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
											EntegratorIdentifiers.SMART === EntegratorConf.identifier
										)
									) && (
										<a
											className="dropdown-item"
											onClick={() => {
												const fullDistributorName = this.findDistributor(row)[0];
												const mainDistributor = fullDistributorName.split(" (")[0];
												this.setState({
													showRequestModal: true,
													selectedCustomer: {
														...row,
														distributorName: mainDistributor
													}
												});
											}}
										>
											<i className="fa fa-envelope"/> Talep Oluştur
										</a>
									)
								}

								{this.props.currentUser.hasDistributorSealAuthority === true &&
									<a className="dropdown-item" onClick={() => this.openFinancialSealModal(row)}>
										<i className="fa fa-id-badge"/> Mali Mühür Başvur
									</a>
								}

							</div>
						</div>
					</div>
				)
			}
		];

		const cagriMerkeziBayiSorumlusuFields = [
			{
				label: "Müşteri Adı",
				accessor: "customerName",
				type: "text",
				operator: "="
			},
			{
				label: "Ünvan",
				accessor: "formattedName",
				type: "text",
				operator: "="
			},
			{
				label: "VKN/TCKN",
				accessor: "vknTckn",
				type: "numericText",
				operator: "="
			},
			{
				label: "Ad",
				accessor: "givenName",
				type: "text",
				operator: "="
			},
			{
				label: "Soyad",
				accessor: "familyName",
				type: "text",
				operator: "="
			},
			{
				label: "Etiket Durumu",
				accessor: "aliases.processState",
				type: "select",
				operator: "=",
				selectData:aliasState
			},
		];

		const fields = [
			{
				label: "Müşteri Adı",
				accessor: "customerName",
				type: "text",
				operator: "="
			},
			{
				label: "Ünvan",
				accessor: "formattedName",
				type: "text",
				operator: "="
			},
			{
				label: "VKN/TCKN",
				accessor: "vknTckn",
				type: "numericText",
				operator: "="
			},
			{
				label: "Ad",
				accessor: "givenName",
				type: "text",
				operator: "="
			},
			{
				label: "Soyad",
				accessor: "familyName",
				type: "text",
				operator: "="
			},
			{
				label: "Hizmet Adı",
				accessor: "customerContractList_customerContractServiceList_service.recordId",
				type: "select",
				operator: "=",
				//selectData: this.serviceTypesSelectData()
				selectData: this.state.services
			},
			{
				label: "Müşteri Tipi",
				accessor: "isDistributor",
				type: "select",
				operator: "=",
				selectData:customerTypeSelectData
			},
			{
				label: "Aktif/Pasif",
				accessor: "isActive",
				type: "select",
				operator: "=",
				selectData:customerIsActiveSelectData
			},
			{
				label: "Etiket Durumu",
				accessor: "aliases.processState",
				type: "select",
				operator: "=",
				selectData:aliasState
			},
			{
				label: "Şehir",
				accessor: "city",
				type: "select",
				operator: "=",
				onOther:this.onChangeCity,
				selectData: this.getCitiesSelectData()
			},
			{
				label: "Vergi Dairesi",
				accessor: "taxOffice",
				type: "select",
				operator: "=",
				selectData: this.getTaxOfficesSelectData()
			},
			{
				label: "Bayi",
				accessor: "parentCustomerId",
				type: "select",
				operator: "=",
				selectData: this.state.distributors
			},
			{
				label: "Aktivasyon Durumu",
				accessor: "aliases.actionType",
				type: "select",
				operator: "=",
				selectData: actionType
			}
		];

		let serviceStateColumns = [
			{
				Header: "Hizmet Adı",
				accessor: "serviceName",
				sortable: false
			},
			{
				Header: "Etiket",
				accessor: "",
				sortable: false,
				Cell: row => (
					<div>
						<label>{row.workScopecode}</label>
						{row.workScopecode !== '-' &&
						<CopyToClipboard text={row.workScopecode}
										 onCopy={() => this.copied(row.workScopecode)}>
							<button className="btn "
									style={{
										padding: "0px 9px 0px 9px",
										margin: "0px",
										backgroundColor: "inherit",
										color: "#78b1d7"
									}}>
								<i class="far fa-copy"></i>
							</button>
						</CopyToClipboard>}
					</div>
				)
			},
			{
				Header: "Talep",
				accessor: "actionType",
				sortable: false
			},
			{
				Header: "İşlem Tarihi",
				accessor: "processStartDate",
				sortable: false
			},
			{
				Header: "GİB'e Gönderim Tarihi",
				accessor: "gibDate",
				sortable: false
			},
			{
				Header: "Açıklama",
				accessor: "explanation",
				sortable: false
			},
			{
				Header:  <div>{this.state.serviceStateList && this.state.serviceStateList.filter(ssl=> {return ssl.isAtGib}).length > 0 ? "GİB'den Sorgula" : null}</div>,
				accessor: "isAtGib",
				sortable: false,
				Cell: row => (
					<div>
						{row.isAtGib &&
							<button
								style={{backgroundColor: 'transparent', border: 'none', fontSize: 'large'}}
								onClick={() => {
									this.gibState(row)
								}}
								title="Gelir İdaresi Başkanlığı'ndan Sorgula"
								disabled={this.state.processing}>
								{this.state.processing &&
									<ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
								<i
									className="fa fa-question-circle">
								</i>
							</button>
						}
					</div>

				)
			},
		];

		if ([EntegratorIdentifiers.KOLAYSOFT,EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier) && this.props.currentUser.isEntegrator === true) {
			serviceStateColumns.push(
				{
					Header: "Seçenek Kodu",
					accessor: "",
					sortable: false,
					Cell: row => (
						<div>
							<label>
								{this.readableOptionCodeName(row.userOptioncode)}
							</label>
						</div>
					)
				})
		}
		serviceStateColumns.push(
			{
				Header: "İşlemler",
				accessor: "",
				sortable: false,
				Cell: (row, index) => (
					<div className="btn-group">
						<CopyToClipboard text={row.envelopeUuid}
										 onCopy={() => this.copyEttn()}>
							<button type="button" rel="tooltip"
									className="Btn btn-icon" title="Zarf Ettn Kopyala"
									disabled={row.envelopeUuid === null}
									style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
								<i className="fa fa-clone"/>
							</button>
						</CopyToClipboard>
						<button type="button" onClick={() =>   this.downloadEnvelopeXml(row, index)} rel="tooltip"
								className="Btn btn-icon" title="Zarf Xml İndir" disabled={row.envelopeUuid === null}
								style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-download"/>
						</button>
					</div>
				)
			}
		)

		return (
			<div className="row baseBackground">
				{!this.props.isEntegrator &&
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name={this.props.name}>

					{!(!this.props.isDistributor && this.props.currentUser.accountant) &&
					<StickButton position="leftSide"
								 onClick={this.handleCreate}
								 label="Yeni Oluştur"
								 title="Yeni Oluştur"
								 className='stickButton plus-circle'
								 icon='plus-circle'/>}

					{!(!this.props.isDistributor && this.props.currentUser.accountant) &&
					<ExcelExporter position="leftSide" url={'/customer/exportXls'}
								   sheetName='Müşteri_Listesi' title="Excel'e Aktar" customExport={true}
								   defaultHeaders={defaultHeaders} type='customer'
								   predications = {this.state.predicate}
								   triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}
								   icon='excel'
								   impersonateUserRoleId={this.props.impersonateUserRoleId}/>}

					{((showExternalPayment(EntegratorConf.identifier ,this.props.currentUser) ||
						(!(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4) && ["smart", "kolaysoft", 'mbtfatura'].includes(VirtualHost.conf.resourcePrefix))) && this.props.currentUser.parentCustomerId === 1) &&
					<StickButton position="leftSide"
								 onClick={this.isExternalPayable}
								 label="Ödeme Yap"
								 title="Ödeme Yap"
								 disabled={this.state.selectedCustomerList.length === 0}
								 className='stickButton'
								 icon='plus-circle'/>}

					{showPriceListModal(EntegratorConf.identifier ,this.props.currentUser) &&
					<StickButton position="leftSide"
								 onClick={this.openPriceListModal}
								 label="Toplu Kontör"
								 title="Toplu Kontör"
								 className='stickButton'
								 icon='plus-circle'/>}

					{showCreditDistributeButton(EntegratorConf.identifier ,this.props.currentUser) &&
						<StickButton position="leftSide"
									 onClick={this.openCreditSalesByDistributorModal}
									 title="Kontör Dağıtımı"
									 label="Kontör Dağıtımı"
									 className='stickButton share'
						/>}
				</NavBarKS>}


				{this.props.isEntegrator &&
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name={this.props.name}>

					{!(!this.props.isDistributor && this.props.currentUser.accountant) &&
					<StickButton position="leftSide"
								 onClick={this.handleCreate}
								 label="Yeni Oluştur"
								 title="Yeni Oluştur"
								 className='stickButton plus-circle'
								 icon='plus-circle'/>}

					{(!this.props.currentUser.accountant && !((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
							EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
							EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser && (this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))) &&
					<ExcelExporter position="leftSide" url={'/customer/exportXls'}
								   sheetName='Müşteri_Listesi' title="Excel'e Aktar" customExport={true}
								   defaultHeaders={defaultHeaders} type='customer' 
								   predications = {this.state.predicate} 
								   triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}
								   icon='excel'
								   impersonateUserRoleId={this.props.impersonateUserRoleId}/>}

					{!(!this.props.isDistributor && this.props.currentUser.accountant) &&
					<SquareButton position="leftSide"
								  title='Yenile'
								  onClick={this.handleConsole}
								  icon='reload' />}

					{!(!this.props.isDistributor && this.props.currentUser.accountant) &&
					<SquareButton position="leftSide"
								  title='Hata Alan Red Faturalar'
								  onClick={() => {this.setState({showDeniedInboxWithError : true})}}
								  icon='ban' />}

					{VirtualHost.conf.resourcePrefix === 'vega' &&
					<SquareButton position="leftSide"
								  title='Sms Raporu'
								  onClick={() => {this.setState({smsExcel : true})}}
								  img="excel-custom-transfer.png" />}

				</NavBarKS>
				}

				{this.state.notify &&
				<Row>
					<NotifyKS
						key={this.state.notifyKey}
						type={this.state.notify.type}
						message={this.state.notify.message}
						html={this.state.notify.html}
						timeout={this.state.notify.timeout}
						autohide={this.state.notify.autohide}
					/>
				</Row>}

				<div className="col-sm-12 satirBasi">

					<div className="">
						<div className="card-header ">
							<h4 className="card-title" >Müşteri Listesi</h4>
						</div>
						<div className="card-body">
							<div className=" ">
								<div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
									<DetailedSearch fields={((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
																EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
																EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser &&
																(this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4)) ? cagriMerkeziBayiSorumlusuFields : fields}
													loading={this.state.searching}
													currentUser={this.props.currentUser}
													onSearch={(e) => {
														((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
																EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
																EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser &&
															(this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4)) ? this.checkRoleIdHandleSearch(e) : this.handleSearch(e)
													}}/>
								</div>
							</div>
						</div>
						<div className="card-body">
							<Table
								columns={columns}
								content={this.state.customers}
								total={this.state.total}
								page={this.state.page}
								size={this.state.size}
								loading={this.state.loading}
								options={["5", "10", "20", "50", "100"]}
								fetchData={this.fetchData}
								manual={this.state.manual}
								jumberEnabled={true}
								currentUser={this.props.currentUser}
							/>
						</div>
					</div>
					{this.state.getCustomerLoading && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
				</div>

				{this.state.showXMLDownloadRequestModal &&
				<XMLDownlaodRequestModal modal={this.state.showXMLDownloadRequestModal}
										 title={"XML İndirme İsteği ( " + this.state.selectedCustomer.vknTckn + " )"}
										 vknTckn={this.state.selectedCustomer.vknTckn}
										 isOpen={(manual) => this.setState({showXMLDownloadRequestModal: false})}
				/>
				}

				{this.state.creditHistoryModal &&
				<CreditHistoryModal isOpen={this.state.creditHistoryModal}
									toggle={this.closeCreditHistoryModal}
									customer={this.state.selectedCustomer}
									isEntegrator={this.props.isEntegrator}
									isDistributor={this.props.isDistributor}
									isAdmin={this.props.isAdmin}
									currentUser={this.props.currentUser}
									priceAmountMap={this.state.priceAmountMap}
									priceAmountMbMap={this.state.priceAmountMbMap}
				/>
				}

				{this.state.externalPaymentModal &&
				<ExternalPaymentModal isOpen={this.state.externalPaymentModal}
									  paytrDomain={this.props.currentUser.paytrDomain}
									  toggle={this.closeExternalPaymentModal}
									  customer={this.state.selectedCustomer}
									  isEntegrator={this.props.isEntegrator}
									  isDistributor={this.props.isDistributor}
									  isAdmin={this.props.isAdmin}
									  currentUser={this.props.currentUser}
				/>
				}

				{this.state.priceListModal  &&
				<DistributorPurchaseModal isOpen={this.state.priceListModal}
									toggle={this.closePriceListModal}
									customer={this.state.selectedCustomer}
									isEntegrator={this.props.isEntegrator}
									isDistributor={this.props.isDistributor}
									isAdmin={this.props.isAdmin}
									currentUser={this.props.currentUser}
									priceAmountMap={this.state.priceAmountMap}
									priceAmountMbMap={this.state.priceAmountMbMap}
				/>
				}

				{this.state.customerNotesModal &&
					<CustomerNotesModal isOpen={this.state.customerNotesModal}
										toggle={this.closeCustomerNotesModal}
										customer={this.state.selectedCustomer}
										currentUser={this.props.currentUser}
					/>
				}

				{this.state.distributorInfoModal &&
					<DistributorInfoModal isOpen={this.state.distributorInfoModal}
										  toggle={this.closeDistributorInfoModal}
										  customer={this.state.selectedCustomer}
										  currentUser={this.props.currentUser}
					/>
				}

				{this.state.additionalServicesModal &&
					<AdditionalServicesModal isOpen={this.state.additionalServicesModal}
										  toggle={this.closeDistributorInfoModal}
										  customer={this.state.selectedCustomer}
										  currentUser={this.props.currentUser}
											 closeModal={this.closeAdditionalServicesModal}
					/>
				}

				{this.state.customerPriceListModal &&
				<CustomerPriceListModal isOpen={this.state.customerPriceListModal}
										toggle={this.closeCustomerPriceListModal}
										customer={this.state.selectedCustomer}
										currentUser={this.props.currentUser}
				/>
				}
				{this.state.connectorPaymentModal &&
					<ConnectorPaymentModal modal={this.state.connectorPaymentModal}
										   toggle={(flag, manual) => this.setState({
											   connectorPaymentModal: flag,
											   manual: manual
										   })}
										   customer={this.state.selectedCustomer}
										   connectionInfo={this.state.connectionInfo}
										   propType={this.state.propType}
										   connectorAlert={this.state.connectorAlert}
										   checkConnectorUpdated={this.state.checkConnectorUpdated}
										   checkConnectorInstallation={this.state.checkConnectorInstallation}
										   currentUser={this.props.currentUser}/>
				}

				<Modal isOpen={this.state.inboxWarningModal} size="lg">
					<ModalHeader toggle={this.closeInboxWarningModal}>Gelen Fatura Uyarı Bilgileri</ModalHeader>
					<ModalBody>
						<InboxWarning selectedCustomer={this.state.selectedCustomer}
									  initialList={this.state.allWarningMails}
									  currentUser={this.props.currentUser}/>
					</ModalBody>
					<ModalFooter>

					</ModalFooter>
				</Modal>

				{this.state.showLoginModal &&
				<DefaultModal title="Müşteri Kullanıcı Listesi"
							  size="md"
							  disabled={this.state.disabledLoginBtn}
							  isOpen={this.state.showLoginModal}
							  confirmBtnText="Giriş Yap"
							  cancelBtnText="Kapat"
							  onConfirm={this.impersonate}
							  onCancel={(e) => this.setState({
								  showLoginModal: false,
								  disabledLoginBtn: false,
								  recordId: null
							  })}
				>

					<FormGroup row>
						<Label sm={4} for="batchEnabled">Kullanıcı: *</Label>
						<Col sm={8}>
							<Select
								clearable={false}
								value={this.state.recordId}
								placeholder="Kullanıcı Seçiniz..."
								onChange={(e) => (e && e.value) && this.setState({recordId: e.value})}
								options={this.state.users.map(user => ({
									value: user[5],
									label: (user[0] || "") + "-" +
									(user[2] || "") + " " +
									(user[3] || "") + (user[1] === 1 ? "( Yönetici )" : "")
								}))}
							/>
						</Col>
					</FormGroup>
				</DefaultModal>
				}

				<Modal isOpen={this.state.serviceStateModal} size='xl'>
					<ModalHeader toggle={this.closeServiceStateModal}>Hizmet Durumu</ModalHeader>
					<ModalBody>
						<div className="card-body">
							<Table
								columns={serviceStateColumns}
								content={this.state.serviceStateList}
								loading={this.state.loading}
								paginationEnabled={false}
							/>
						</div>
						{this.state.result &&
							<SweetAlertExt sm={12}
										   confirmBtnText="Tamam"
										   onConfirm={() => this.reset()}
								   style={this.state.code === 999 ? {color: "crimson", marginTop: '0,5px'} : {color: "midnightblue", marginTop: '0,5px'}}
										   confirmButtonText="Tamam">
								{this.state.result}
							</SweetAlertExt>
						}
					</ModalBody>
				</Modal>

				<CustomerChangeVknTcknModal
					isOpen={this.state.changeVknTcknModal}
					toogle={this.closeCustomerChangeVknTcknModal}
					customer={this.state.selectedCustomer}
					onUpdateVknTckn={this.updateVknTckn}

				/>

				<AssignCustomerModal show={this.state.assignCustomerModal}
									 selectedAccountant={this.state.selectedAccountant}
									 title="Muhasebeciye Müşteri Ata" closeAssignModal={this.closeAssignModal}
									 assignedCustomers={this.state.assignedCustomers}
									 showNotification={this.showNotification}/>

				{this.state.showDeniedInboxWithError &&
					<DeniedInboxWithErrorList
					showDeniedInboxWithError = {this.state.showDeniedInboxWithError}
					close = {() => this.setState({showDeniedInboxWithError : false})}
					source = {this.state.source}/>
				}
				{this.state.smsExcel &&
					<SmsReportToExcel
						closeClickSms={this.closeClickSms}
						close = {() => this.setState({smsExcel : false})}
						sheetName='Sms Raporu'
						controllerName={"eArchive"}
						triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}
						url='/eArchive/exportXls'/>
				}
				{this.state.externalModal &&
					<ExternalPayTrModal
						paytrDomain={this.props.currentUser.paytrDomain}
						modal={this.state.externalModal}
						customerList={this.state.eBelgeUsers}
						toggle={() => this.setState({externalModal: false})}
					/>
				}

				{this.state.creditSalesByDistributorModal  &&
					<CreditSalesByDistributorModal
							isOpen={this.state.creditSalesByDistributorModal}
						  	toggle={this.closeCreditSalesByDistributorModal}
						  	isEntegrator={this.props.isEntegrator}
						  	isDistributor={this.props.isDistributor}
						  	isAdmin={this.props.isAdmin}
						  	currentUser={this.props.currentUser}
					/>
				}

				{this.state.showRequestModal &&
					<CustomerRequestModal
						modal={this.state.showRequestModal}
						onClose={this.closeRequestModal}
						customer={this.state.selectedCustomer}
					/>
				}

				{this.state.showFinancialSealModal &&
					<FinancialSealModal
						paytrDomain={this.props.currentUser.paytrDomain}
						modal={this.state.showFinancialSealModal}
						onClose={this.closeFinancialSealModal}
						customer={this.state.selectedCustomer}
					/>
				}

			</div>
		);
	}
}

export default CustomerList;
